import React from 'react';
import ClassAssembly  from 'views/ClassAssembly4C2023';

const ClassAssemblyPage = () => {
    return <ClassAssembly />;
  };
  
export default ClassAssemblyPage;